/**
 * @fileoverview added by tsickle
 * Generated from: serializers/worker-metrics-classification.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingRequire,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { modelSerializer } from '../util/serializers';
import { metricsClassification } from '../models/worker-metrics-classification';
/** @type {?} */
export var metricsClassificationSerializer = (/** @type {?} */ ((/** @type {?} */ (modelSerializer.extend({
    model: metricsClassification
})))));
